<template>
	<div class="bg-bottom ">
		<div class="justify-space-between">
			<button
				@click="onSide"
				class="flex-1"
			><v-icon>mdi mdi-menu</v-icon></button>
			<button
				@click="toHome"
				class="flex-1"
			><v-icon>mdi mdi-home</v-icon></button>

			<button
				@click="toMyPage"
				class="flex-1"
			><v-icon>mdi mdi-account</v-icon></button>
			<button
				@click="toLogout"
				class="flex-1"
			><v-icon>mdi mdi-logout</v-icon></button>
		</div>
	</div>
</template>

<script>
export default{
	name: 'Bottom'
	, components: {}
	, props: []
	,data: function(){
		return {
			items_notice: []
			, title: process.env.VUE_APP_NAME
		}
	}
	, computed: {
		is_home: function(){
			if(this.$route.path == '/Index'){
				return true
			}else{
				return false
			}
		}
		,is_cart: function(){
			if(this.$route.path == '/Cart'){
				return true
			}else{
				return false
			}
		}
		,is_delivery: function(){
			if(this.$route.path == '/Order/List'){
				return true
			}else{
				return false
			}
		}
		,is_mypage: function(){
			if(this.$route.path.indexOf('/Account') > -1){
				return true
			}else{
				return false
			}
		}
		, is_call: function(){
			let t = false

			if(this.$route.name == 'Index'){
				t = true
			}
			return t
		}
	}
	,methods: {
		toHome: function(){
			this.$bus.$emit('to', { name: 'Index'})
		}
		,toMyPage: function(){
			this.$bus.$emit('to', { name: 'MyPage'})
		}
		,toCart: function(){
			this.$bus.$emit('to', { name: 'Cart'})
		}
		,toOrderList: function (){
			this.$bus.$emit('to', { name: 'OrderList'})
		}
		,onSide: function(){
			this.$emit('toggleSide')
		}
		, toBoard: function(){
			this.$bus.$emit('to', { name: 'BbsItem', params: { b_code: 'b_qna' }})
		}
		, toAuth: function(type){
			this.$bus.$emit('to', { name: 'Auth', params: {type: type}})
		}
		, toLogout: function(){
			if(confirm("로그아웃 하시겠습니까?")){
				this.$bus.$emit('logout')
			}
		}
	}
}
</script>

<style>
</style>